import styled from 'styled-components';

export default function PublishAlert({ message, onClose }) {
  if (!message) return null;
  return <Backdrop role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
    <Dialog role="alertdialog" aria-modal="true" aria-labelledby="publish-alert-title">
      <span>REVISÁ ESTE DATO</span>
      <h2 id="publish-alert-title">Falta información</h2>
      <p>{message}</p>
      <button type="button" onClick={onClose}>Entendido</button>
    </Dialog>
  </Backdrop>;
}

const Backdrop = styled.div`position:fixed;z-index:1500;inset:0;display:grid;place-items:center;padding:20px;background:rgba(28,46,50,.44);backdrop-filter:blur(7px);`;
const Dialog = styled.section`width:min(100%,420px);padding:26px;border-radius:22px;color:#29474f;background:#fff;box-shadow:0 28px 72px rgba(20,35,39,.3);>span{color:#b45f40;font-size:11px;font-weight:850;letter-spacing:.15em;}h2{margin:9px 0 8px;font-size:27px;line-height:1.05;letter-spacing:-.04em;}p{margin:0;color:#67787b;font-size:15px;line-height:1.52;}button{width:100%;min-height:49px;margin-top:22px;border:0;border-radius:14px;color:#fff;background:#c66f4e;font:inherit;font-size:15px;font-weight:800;cursor:pointer;}`;
